/*
if (!customElements.get("count-down")) {
  class Countdown extends HTMLElement {
    connectedCallback() {
      this.expiryISO = this.getAttribute("data-expiry");

      if (!this.expiryISO) {
        console.error("countdown: Required attributes not found");
        return;
      }

      this.expiryDate = new Date(this.expiryISO);
      const difference = this.expiryDate - new Date();
      this.differenceInDays = Math.floor(difference / (1000 * 60 * 60 * 24));
      this.differenceInHours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

      this.daysSpan = this.querySelector(".js-days");
      this.hoursSpan = this.querySelector(".js-hours");

      if (this.daysSpan) {
        this.daysSpan.textContent = this.differenceInDays;
      }

      if (this.hoursSpan) {
        this.hoursSpan.textContent = this.differenceInHours;
      }
    }
  }

  customElements.define("count-down", Countdown);
}
*/

/* version with smaller scale */

if (!customElements.get("count-down")) {
  class Countdown extends HTMLElement {
    connectedCallback() {
      this.startISO = this.getAttribute("data-start");
      this.expiryISO = this.getAttribute("data-expiry");

      if (!this.expiryISO) {
        console.error("countdown: Required attributes not found");
        return;
      }

      this.startDate = this.startISO ? this.parseLocalDate(this.startISO) : null;
      this.expiryDate = this.parseLocalDate(this.expiryISO);

      this.daysGroup = this.querySelector(".countdown-days");
      this.hoursGroup = this.querySelector(".countdown-hours");
      this.minutesGroup = this.querySelector(".countdown-minutes");

      this.daysSpan = this.querySelector(".js-days");
      this.hoursSpan = this.querySelector(".js-hours");
      this.minutesSpan = this.querySelector(".js-minutes");      

      this.offerBar = document.querySelector(".offer-bar-main");
      this.offerBarPdp = document.querySelector(".pdp_offer_banner");      

      // Run immediately, then every minute
      this.updateCountdown();
      this.interval = setInterval(() => this.updateCountdown(), 60000);      

      // const difference = this.expiryDate - new Date();

      // this.differenceInHours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      // this.differenceInMinutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));

      // this.hoursSpan = this.querySelector(".js-hours");
      // this.minutesSpan = this.querySelector(".js-minutes");

      // if (this.hoursSpan) {
      //   this.hoursSpan.textContent = this.differenceInHours;
      // }

      // if (this.minutesSpan) {
      //   this.minutesSpan.textContent = this.differenceInMinutes;
      // }
    }
    // Parse string like "2025-11-30 23:59" as local time
    parseLocalDate(str) {
      if (!str) return null;
      const [datePart, timePart] = str.trim().split(" ");
      const [year, month, day] = datePart.split("-").map(Number);
      const [hour, minute] = timePart ? timePart.split(":").map(Number) : [0, 0];
      return new Date(year, month - 1, day, hour, minute, 0);
    }    
    updateCountdown() {
      const now = new Date();

      // Hide countdown if not started or expired
      if ((this.startDate && now < this.startDate) || now > this.expiryDate) {
        if (this.offerBar) this.offerBar.style.display = "none";
        if (this.offerBarPdp) this.offerBarPdp.style.display = "none";        
        clearInterval(this.interval);
        return;
      }

      if (this.offerBar) this.offerBar.style.display = "";
      if (this.offerBarPdp) this.offerBarPdp.style.display = "";        

      const diff = this.expiryDate - now;

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);

      // Toggle visibility depending on remaining time
      if (days >= 1) {
        // Show days + hours
        this.daysGroup.style.display = "";
        this.hoursGroup.style.display = "";
        this.minutesGroup.style.display = "none";
      } else {
        // Show hours + minutes only
        this.daysGroup.style.display = "none";
        this.hoursGroup.style.display = "";
        this.minutesGroup.style.display = "";
      }

      if (this.daysSpan) this.daysSpan.textContent = days;
      if (this.hoursSpan) this.hoursSpan.textContent = hours;
      if (this.minutesSpan) this.minutesSpan.textContent = minutes;
    }    
  }

  customElements.define("count-down", Countdown);
}
